import { render, staticRenderFns } from "./bind-data.vue?vue&type=template&id=2c677314&scoped=true&"
import script from "./bind-data.vue?vue&type=script&lang=js&"
export * from "./bind-data.vue?vue&type=script&lang=js&"
import style0 from "./bind-data.vue?vue&type=style&index=0&id=2c677314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c677314",
  null
  
)

export default component.exports